import { getImageUrl } from '@/lib/cdn';

export const FEEDBACK_DATA = [
  {
    name: 'Stephen Prince',
    title: 'CEO, Vutility',
    imageUrl: 'https://assets.marketbetter.ai/images/testimonials/stephen_prince.jpeg',
    testimonial:
      'As CEO, I care about speed to lead and pipeline efficiency. MarketBetter helped our SDRs respond faster, prioritize warm accounts, and keep every touch logged without extra admin work.',
    secondaryTestimonial:
      'The team spends more time selling, less time figuring out what to do next.',
    logoUrl: 'https://media.marketbetter.ai/marketing/vutility_white.svg',
    linkedinUrl: 'https://www.linkedin.com/in/stephen-prince-2378564',
    stat1Value: '2X',
    stat1Label: 'Faster Speed to Lead',
    stat2Value: '85%',
    stat2Label: 'Pipeline Efficiency Gain',
  },
  {
    name: 'Peter Sfraga',
    title: 'VP, Marketing, IT Healthcare Leaders',
    imageUrl: 'https://assets.marketbetter.ai/images/testimonials/peter_sfraga.jpeg',
    testimonial:
      'Our chatbot leads used to sit too long before an SDR touched them. MarketBetter routes chatbot conversations to the right rep immediately, creates the follow-up tasks, and makes sure the response happens fast.',
    secondaryTestimonial:
      "That speed alone changed the quality of conversations we're getting.",
    logoUrl: 'https://assets.marketbetter.ai/images/testimonials/hcitl_white.png',
    linkedinUrl: 'https://www.linkedin.com/in/petersfraga/',
    stat1Value: '90%',
    stat1Label: 'Faster Lead Response',
    stat2Value: '2X',
    stat2Label: 'Improvement in Conversations',
  },
];

export const HEYGEN_TERMINATORS_DATA = [
  {
    name: 'Manny Hernandez',
    title: 'Head of Americas',
    imageUrl: 'https://media.marketbetter.ai/marketing/manny_h.jpeg',
    testimonial: `We used to waste hours researching and personalizing outreach manually. With MarketBetter's AI agents and HeyGen videos, every pitch felt tailored—and it was. Our sales cycle shortened dramatically, and reps could finally focus on closing.`,
    logoUrl: 'https://media.marketbetter.ai/marketing/queclink_white.svg',
    linkedinUrl: 'https://www.linkedin.com/in/mannyhernandez',
    stat1Value: '80%',
    stat1Label: 'Increase in Sales Efficiency',
    stat2Value: '2.8x',
    stat2Label: 'Faster Lead Conversion',
  },
  {
    name: 'Landon Garner',
    title: 'Chief Marketing Officer',
    imageUrl: 'https://media.marketbetter.ai/marketing/lg_cmo_kajeet.webp',
    testimonial:
      'Before MarketBetter, our cold outreach felt robotic. Now, every lead receives a video that speaks directly to their pain points. It feels human—because it is. And it’s all automated.',
    logoUrl: 'https://media.marketbetter.ai/marketing/kajeet.svg',
    linkedinUrl: 'https://www.linkedin.com/in/landongarner',
    stat1Value: '5x',
    stat1Label: 'Increase in Response Rate',
    stat2Value: '70%',
    stat2Label: 'More Booked Meetings',
  },
  {
    name: 'Adam Grant',
    title: 'Head of Demand',
    imageUrl: 'https://media.marketbetter.ai/marketing/1928_Adam_G.jpg',
    testimonial:
      'MarketBetter’s video workflows helped us break through the noise. Prospects actually watched, replied, and booked. And we saved over 60 hours per month on manual outreach.',
    logoUrl: 'https://media.marketbetter.ai/marketing/twnex_white.svg',
    linkedinUrl: 'https://www.linkedin.com/in/adam-grant-81b906263/',
    stat1Value: '85%',
    stat1Label: 'Increase in Response Rate',
    stat2Value: '$78K',
    stat2Label: 'Saved in Rep Hours Annually',
  },
];

// Brand logos for "Trusted by" section - grayscale versions
export const BRAND_LOGOS = [
  // New grayscale logos from R2
  { name: 'AidKit', url: 'https://assets.marketbetter.ai/images/logo/aidkit_gray.png' },
  { name: 'EcoOnline', url: 'https://assets.marketbetter.ai/images/logo/ecoonline_grayscale.png' },
  { name: 'Exabeam', url: 'https://assets.marketbetter.ai/images/logo/exabeam_grayscale.png' },
  { name: 'Hologram', url: 'https://assets.marketbetter.ai/images/logo/hologram_greyscale.png' },
  { name: 'LevelBlue', url: 'https://assets.marketbetter.ai/images/logo/levelblue_grayscale.png' },
  { name: 'Soracom', url: 'https://assets.marketbetter.ai/images/logo/soracom_gray.png' },
  { name: 'Vutility', url: 'https://assets.marketbetter.ai/images/logo/vutility_gray.png' },
  // Original logos (local paths)
  { name: 'FloLive', url: getImageUrl('brand/brand-light-01.svg') },
  { name: 'Kajeet', url: getImageUrl('brand/brand-light-03.svg') },
  { name: 'AT&T', url: getImageUrl('brand/brand-light-11.svg') },
  { name: 'Telekom', url: getImageUrl('brand/telekom.svg') },
  { name: 'Queclink', url: getImageUrl('brand/queclink.svg') },
];
